﻿import React, { useState, useEffect } from 'react';
import { BenchSheetHeader } from '../models/bench-sheet-header';
import { LookupItem } from '../models/lookup-item';
import { ContextMenuComponent } from './ContextMenuComponent';
import TextNoteEditor from './Common/TextNoteEditor';
import BenchSheetBatchReferencesComponent from './BenchSheetBatchReferencesComponent';
import MethodHtmlDescriptionComponent from './Methods/MethodHtmlDescriptionComponent';
import { FieldUpdate } from '../models/field-update';
import { CrudFunctions } from '../utilities/crud-functions';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType, BenchSheetReferenceType, NoteType } from '../models/enums';
import { RenderingFunctions } from '../utilities/rendering-functions';

import Tabs, { Item as TabItem } from 'devextreme-react/tabs';
//import type { Item } from 'devextreme/ui/tabs';
import TextBox from 'devextreme-react/text-box';
import SelectBox from 'devextreme-react/select-box';
import Button from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';

let key = 0;
export interface Props {
    benchSheetId?: string;
    fixedReference?: string;
    readOnly?: boolean;
}

const tabsConfig = [
    {
        id: 0,
        text: 'Main',
        icon: 'info',
    },
    {
        id: 1,
        text: 'Chemical',
        icon: 'overflow',
    },
    {
        id: 2,
        text: 'Appearance',
        icon: 'eyeopen',
    },
    /* PER MB 4/17/26: Not ready for this yet; hide for now */
    //{
    //    id: 3,
    //    text: 'Standards',
    //    icon: 'taskcomplete',
    //}
];

export enum HeaderTabType {
    Main = 0,
    Chemical = 1,
    Appearance = 2,
    /*Standards = 3*/
}

export default function BenchSheetHeaderComponent(props: Props) {
    const [header, setHeader] =
        useState<BenchSheetHeader>();

    const [selectedTab, setSelectedTab] =
        useState<HeaderTabType>(HeaderTabType.Main);

    const [referenceTypes, setReferenceTypes] =
        useState<LookupItem[]>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [batchReferencesComponentVisible, setBatchReferencesComponentVisible] =
        useState<boolean>();

    const [dataLoaded, setDataLoaded] =
        useState<boolean>();

    useEffect(() => {
        if (!dataLoaded)
            getData();
    }, [props.benchSheetId]);

    key++;

    let productStateColor = () => {
        if (header && header.batchPartState) {
            let cssClass = RenderingFunctions.returnProductStateColor(header.batchPartState);
            return `pw-readonly-label ${cssClass}`;
        }
        return "pw-readonly-label";
    }

    const renderCustomItem = () => {
        return <div>Custom Item</div>;
    }


    return (
        <div>
            <div className="lq-header aurum-light-blue-bg">
                <div className="lq-header-title">Header</div>
                <div className="pw-right-align-content">
                    <Button icon="columnchooser" hint="batch references" type="success"
                        onClick={onBatchReferencesClick} />
                </div>
            </div>

            <div className="pw-form-section">

                <div style={{ display: "flex", alignItems: "center" }}>
                    <div>
                        <Tabs
                            id="withText"
                            onSelectedIndexChange={onSelectedTabIndexChange}
                            defaultSelectedIndex={0}
                            dataSource={tabsConfig}
                            scrollByContent={true}
                            showNavButtons={true}
                            orientation="horizontal"
                            stylingMode="primary"
                            width={500}
                            iconPosition="start">
                        </Tabs>
                    </div>
                </div>

                {selectedTab === HeaderTabType.Main &&
                    <div className="pw-margin-top-1">
                        <div>
                            <div className="pw-comp-row">
                                <div className="pw-form-unit pw-comp-12">
                                    <div className="pw-form-unit-label">Part Number</div>
                                    <div className={productStateColor()}>{header && header.batchPartNumber ?
                                        header.batchPartNumber : ''}</div>
                                </div>
                                <div className="pw-form-unit pw-comp-12">
                                    <div className="pw-form-unit-label">Batch Name</div>
                                    <div className="pw-readonly-label">{header && header.batchName ?
                                        header.batchName : ''}</div>
                                </div>
                                <div className="pw-form-unit">
                                    <div className="pw-form-unit-label">Basis Types</div>
                                    <div className="pw-readonly-label">{header && header.basisTypes ?
                                        header.basisTypes.join(', ') : 'NA'}</div>
                                </div>
                            </div>

                            <div className="pw-comp-row">
                                <div className="pw-form-unit">
                                    <div className="pw-form-unit-label">Specification</div>
                                    <div className="pw-readonly-label">{header && header.specification ?
                                        header.specification : 'NA'}</div>
                                </div>
                            </div>

                            <div className="pw-comp-row">
                                <div className="pw-form-unit pw-comp-12">
                                    <div className="pw-form-unit-label">Method Number</div>
                                    <div className="pw-readonly-label">{header && header.methodName ?
                                        header.methodName : 'NA'}</div>
                                </div>

                                <div className="pw-form-unit pw-comp-12">
                                    <div className="pw-form-unit-label">Testing Method</div>
                                    <div className="pw-readonly-label">{header && header.testingLocationName ?
                                        header.testingLocationName : 'NA'}</div>
                                </div>

                                <div className="pw-form-unit pw-comp-12">
                                    <div className="pw-form-unit-label">Method Source</div>
                                    <div className="pw-readonly-label">{header && header.methodSourceName ?
                                        header.methodSourceName : 'NA'}</div>
                                </div>

                                {(header && header.methodDocumentSection) &&
                                    <div className="pw-form-unit pw-comp-20">
                                        <div className="pw-form-unit-label">Method Document Section</div>
                                        <div className="pw-readonly-label">{header && header.methodDocumentSection ?
                                            header.methodDocumentSection : 'NA'}</div>
                                    </div>
                                }
                               
                            </div>

                            <div className="pw-margin-top-05">
                                <div className="pw-form-unit-label">Product General Specification</div>
                                <TextNoteEditor parentId={header && header.productId ? header.productId : null}
                                    noteType={NoteType.ProductGeneralSpec} height="6rem" readOnly={true} />
                            </div>
                        </div>

                    </div>
                }

                {selectedTab === HeaderTabType.Chemical &&
                    <>
                        <div className="pw-margin-top-1 pw-comp-row">
                            <div className="pw-form-unit pw-comp-12">
                                <div className="pw-form-unit-label">Molecular Weight</div>
                                <div className="pw-readonly-label">{header && header.molecularWeight ?
                                    header.molecularWeight : 'Na'}</div>
                            </div>
                            <div className="pw-form-unit pw-comp-12">
                                <div className="pw-form-unit-label">CAS #</div>
                                <div className="pw-readonly-label">{header && header.casNumber ?
                                    header.casNumber : 'NA'}</div>
                            </div>
                            <div className="pw-form-unit pw-comp-30">
                                <div className="pw-form-unit-label">Chemical Formula</div>
                                <div className="pw-readonly-label">{header && header.chemicalFormula ?
                                    header.chemicalFormula : 'NA'}</div>
                            </div>
                        </div>

                        <div className="pw-comp-row">
                            <div className="pw-form-unit pw-comp-12">
                                <div className="pw-form-unit-label">SMILES</div>
                                <div className="pw-readonly-label">{header && header.smiles ?
                                    header.smiles : 'NA'}</div>
                            </div>
                        </div>
                    </>
                }

                {selectedTab === HeaderTabType.Appearance &&
                    <div className="pw-margin-top-1 pw-form-unit">
                        <div className="pw-form-unit-label"> Appearance </div>
                        <div className="pw-readonly-label">{header && header.formattedAppearanceString}</div>
                    </div>
                }

                {/* PER MB 4/17/26: Not ready for this yet; hide for now */}
                {/*{selectedTab === HeaderTabType.Standards &&*/}
                {/*    <div>*/}
                {/* TODO see if we can use BatchStandardsComponentData component here */}
                {/*    </div>    */}
                {/*}*/}

            </div>

            {header && header.methodId &&
                <div>
                    <div className="pw-form-unit-label">Method </div>
                    <MethodHtmlDescriptionComponent methodId={header && header.methodId ? header.methodId : undefined} />
                </div>
            }

            {batchReferencesComponentVisible &&
                <DialogPopup visible={batchReferencesComponentVisible}
                    onHiding={hideBatchReferencesComponentVisible}
                    title="Batch References"
                    width='55rem'
                    height='40rem'
                    dragEnabled={true}
                    resizeEnabled={true}>
                    <BenchSheetBatchReferencesComponent benchSheetId={props.benchSheetId}
                        onClose={onBenchSheetBatchReferencesComponentClose}
                        key={`BR${key}`} />
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    function onSelectedTabIndexChange(e: any) {
        //console.log("onSelectedTabIndexChange()", e);
        setSelectedTab(e);
    }

    function onBenchSheetBatchReferencesComponentClose() {
        setBatchReferencesComponentVisible(false);
    }

    function onBatchReferencesClick() {
        setBatchReferencesComponentVisible(true);
    }

    async function referenceTypeChanged(e: any) {
        if (!header || !dataLoaded)
            return;

        const caller = e.element.id as string;
        const currentValue = header[caller];

        if (currentValue === e.value)
            return;
        else if (!currentValue && !e.value)
            return;
        if (!e.value && !e.previousValue)
            return;

        setHeader({ ...header, [caller]: e.value });

        if (referenceTypes) {
            let matchingReferenceType = referenceTypes.filter(rt => rt.id === e.value);

            if (matchingReferenceType && matchingReferenceType.length > 0) {
                let fieldUpdate: FieldUpdate = {
                    entity: "BenchSheets",
                    field: caller,
                    value: matchingReferenceType[0].id,
                    rowId: props.benchSheetId
                };

                await updateBenchSheetField(fieldUpdate)
                    .catch((res) => {
                        let mm: ModalMetadata = {
                            error: res,
                            mode: ModalMessageType.Error,
                            title: "Reference Type Update Error"
                        };

                        setGlobalDialogMetadata(mm);
                        setGlobalDialogVisible(true);
                    });
            }
        }
    }

    async function valueChanged(e: any) {
        if (!header || !dataLoaded)
            return;

        const caller = e.element.id as string;
        const currentValue = header[caller];

        if (currentValue === e.value)
            return;
        else if (!currentValue && !e.value)
            return;
        if (!e.value && !e.previousValue)
            return;

        setHeader({ ...header, [caller]: e.value });

        let fieldUpdate: FieldUpdate = {
            entity: "BenchSheets",
            field: caller,
            value: e.value,
            rowId: props.benchSheetId
        };

        await updateBenchSheetField(fieldUpdate)
            .catch((res) => {
                let mm: ModalMetadata = {
                    error: res,
                    mode: ModalMessageType.Error,
                    title: "Database Update Error"
                };

                setGlobalDialogMetadata(mm);
                setGlobalDialogVisible(true);
            });
    }

    async function getBenchSheetHeaderData() {
        if (!props.benchSheetId)
            return;

        await CrudFunctions.getData(`benchsheets/benchsheetheader/${props.benchSheetId}`)
            .then(data => {
                console.log("header data", data);
                setHeader(data);
            })
            .catch((res) => {
                let mm: ModalMetadata = {
                    error: res,
                    mode: ModalMessageType.Error,
                    title: "Error Loading Bench Sheet Header Data"
                };

                setGlobalDialogMetadata(mm);
                setGlobalDialogVisible(true);
            });
    }

    async function getReferenceTypes() {
        await CrudFunctions.getData("common/benchsheetreferencetypes")
            .then(data => {
                setReferenceTypes(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Reference Types");
            });
    }

    async function updateBenchSheetField(fieldUpdate: FieldUpdate) {
        return await CrudFunctions.putData("benchsheets/benchsheetfield", fieldUpdate);
    }

    async function getData() {
        await Promise.all([
            getBenchSheetHeaderData(),
            getReferenceTypes()
        ])
            .then(() => {
                setDataLoaded(true);
            })
    }


    function hideBatchReferencesComponentVisible() {
        setBatchReferencesComponentVisible(false);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

}
